<div class="team-add-main-container">
  <ng-scrollbar
    [autoHeightDisabled]="false"
    [autoWidthDisabled]="false"
    fxFlex="auto"
  >
    <div class="scroll-content">
      <form [formGroup]="teamForm" class="form-content">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ 'Team Names' | platformLabel }}</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            formControlName="name"
            placeholder="Required"
            id="team-name-input"
          />
          @if (teamForm.get('name').hasError('unique')) {
            <mat-error>
              {{ teamForm.get('name').getError('unique') }}
            </mat-error>
          }
          @if (teamForm.get('name').hasError('notEmpty')) {
            <mat-error>
              {{ teamForm.get('name').getError('notEmpty') }}
            </mat-error>
          }
          @if (teamForm.get('name').hasError('minlength')) {
            <mat-error> Team name must be at least 4 characters </mat-error>
          }
          @if (teamForm.get('name').hasError('maxlength')) {
            <mat-error> Team name can be at most 255 characters </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Public Name</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            formControlName="publicName"
            id="public-team-name-input"
          />
          @if (teamForm.get('publicName').hasError('minlength')) {
            <mat-error> Team name must be at least 4 characters </mat-error>
          }
          @if (teamForm.get('publicName').hasError('maxlength')) {
            <mat-error> Team name can be at most 255 characters </mat-error>
          }
        </mat-form-field>
        <div fxLayoutAlign="space-between" formGroupName="dateGroup">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="startDate"
              placeholder="Optional"
              [errorStateMatcher]="matcher"
              id="team-startdate-input"
            />
            <mat-datepicker-toggle matSuffix [for]="startPicker">
            </mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            @if (dateFormGroup.hasError('startDateBeforeEndDate')) {
              <mat-error> Start date must be before the end date </mat-error>
            }
            @if (dateFormGroup.hasError('requiredStartDate')) {
              <mat-error>
                Start date is required if an end date is set
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="endDate"
              placeholder="Optional"
              id="team-enddate-input"
            />
            <mat-datepicker-toggle matSuffix [for]="endPicker">
            </mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        @if (attributesDataSource.hasAttributes) {
          <mat-divider></mat-divider>
        }
        @if (attributesDataSource.hasAttributes) {
          <attributes-editor
            class="make-labels-grey"
            [dataSource]="attributesDataSource"
            [onTeamForm]="true"
            [mode]="teamDetailsMode"
            fxFlexWidth="100%"
          >
          </attributes-editor>
        }
        @if (attributesDataSource.hasAttributes) {
          <mat-divider></mat-divider>
        }
        <div formArrayName="positions">
          <h3>Positions</h3>
          @for (
            positionFormGroup of positionFormGroups;
            track positionFormGroup;
            let i = $index
          ) {
            <div [formGroupName]="i">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                fxFlex
                class="position-title"
              >
                <input
                  matInput
                  forbidAngleBrackets
                  type="text"
                  placeholder="Title"
                  formControlName="title"
                  id="position-title-input"
                />
                @if (positionFormGroup.get('title').hasError('notEmpty')) {
                  <mat-error>
                    {{ positionFormGroup.get('title').getError('notEmpty') }}
                  </mat-error>
                }
                @if (positionFormGroup.get('title').hasError('noPipe')) {
                  <mat-error>
                    {{ positionFormGroup.get('title').getError('noPipe') }}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                fxFlex="18%"
                class="position-count"
              >
                <input
                  matInput
                  type="number"
                  min="1"
                  placeholder="Seats"
                  formControlName="count"
                  id="position-count-input"
                />
              </mat-form-field>
              <div fxFlex="40px">
                <button
                  class="delete-position"
                  mat-icon-button
                  (click)="removePosition(i)"
                  type="button"
                  aria-label="Delete position"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
        <div>
          <button
            class="add-position-button"
            mat-button
            color="primary"
            (click)="addPosition()"
            type="button"
            aria-label="Add another position"
          >
            <mat-icon>add</mat-icon>Position
          </button>
        </div>
      </form>
    </div>
  </ng-scrollbar>
</div>
